<template>
    <div class="news-list__app">
        <div class="col-wrapper -max-width-limited" v-if="industries.length || categories.length || availableYears.length">
            <div class="col">
                <div class="module-filter-form" ref="filterform">
                    <div class="filter-form__form form">
                        <div class="form-wrapper -bg-white">
                            <div class="col" v-if="industries.length">
                                <NewsFilter
                                        identifier="industries"
                                        :label="$t('filter.industries')"
                                        :options="industries"
                                        v-model="selectedIndustries"/>
                            </div>
                            <div class="col" v-if="categories.length">
                                <NewsFilter
                                        identifier="categories"
                                        :label="$t('filter.categories')"
                                        :options="categories"
                                        v-model="selectedCategories"/>
                            </div>
                            <div class="col" v-if="availableYears.length">
                                <NewsFilter
                                        identifier="years"
                                        layout="radio"
                                        :label="$t('filter.year.title')"
                                        :options="availableYears"
                                        :value="[selectedYear]"
                                        @input="selectedYear = $event"/>
                            </div>
                        </div>
                    </div>
                    <div class="filter-form__selected" v-if="selectedIndustries.length || selectedCategories.length || selectedYear !== null">
                        <div class="selected__wrapper">
                            <div class="selected__item"
                                 v-for="industry in industries.filter(item => selectedIndustries.includes(item.uid))"
                                 :key="`industry-selected-${industry.uid}`"
                                 @click="selectedIndustries = selectedIndustries.filter(selected => selected !== industry.uid)">
                                <span class="icon-times-after">{{ industry.name }}</span>
                            </div>
                            <div class="selected__item"
                                 v-for="category in categories.filter(item => selectedCategories.includes(item.uid))"
                                 :key="`category-selected-${category.uid}`"
                                 @click="selectedCategories = selectedCategories.filter(selected => selected !== category.uid)">
                                <span class="icon-times-after">{{ category.name }}</span>
                            </div>
                            <div class="selected__item" v-if="selectedYear !== null" @click="selectedYear = null">
                                <span class="icon-times-after">{{ availableYears[selectedYear].name }}</span>
                            </div>
                        </div>
                        <div class="selected__reset">
                            <span class="link" @click="reset()"><span>{{ $t('filter.reset') }}</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-wrapper -max-width-limited">
            <div class="col">
                <div class="content-item module-news">
                    <div class="news-wrapper" v-if="!initialized || newsLoading">
                        <template v-for="n in currentPage * itemsPerPage">
                            <div class="news__item news__item--loading" :key="n">
                                <div class="item__image"></div>
                                <div class="item__content">
                                    <div class="content__date"><span></span></div>
                                    <div class="content__headline"><span></span><span></span></div>
                                    <div class="content__text"><span></span><span></span><span></span></div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="news-wrapper" v-else>
                        <template v-for="item in news">
                            <TypoLink :link="item.link" class="news__item -bg-white" :key="item.localizedUid">
                                <div class="item__image">
                                    <img :src="item.image.split('|')[0]" :title="item.image.split('|')[1]"
                                         :alt="item.image.split('|')[2]">
                                </div>
                                <div class="item__content">
                                    <div class="content__date">
                    <span class="heading zeta -color-grey-light">
                      {{
                            $moment(item.date)
                                    .format(dateFormat)
                        }}
                    </span>
                                    </div>
                                    <div class="content__headline">
                    <span class="heading delta -color-text-alpha">
                      {{ item.name }}
                    </span>
                                    </div>
                                    <div class="content__text">
                                        <p class="meta -color-text-alpha">
                                            {{ item.text }}
                                        </p>
                                    </div>
                                </div>
                            </TypoLink>
                        </template>
                        <div class="news__item news__item--placeholder"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-wrapper -max-width-limited">
            <div class="col">
                <div class="content-item module-load-more">
                    <div class="load-more__button" v-if="currentPage < numberOfPages">
                        <div class="btn -btn-alpha" @click="loadMore">
                            <span>{{ $t('loadMore.btn') }}</span>
                        </div>
                    </div>
                    <div class="load-more__progress" v-if="initialized">
                        <div class="progress__info">
                            <span class="meta" v-html="$t('loadMore.info', { current: news.length, total: numberOfTotalItems })"></span>
                        </div>
                        <div class="progress__bar"><span :style="{ width: (news.length / numberOfTotalItems * 100) + '%' }"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsFilter from '@/components/NewsFilter'
import TypoLink from '@/components/TypoLink'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      dateFormat: window.app.news_list.date_format.replace('%d', 'DD')
        .replace('%m', 'MM')
        .replace('%Y', 'YYYY')
    }
  },
  computed: {
    ...mapState({
      initialized: state => state.initialized,
      availableYears: state => state.news.availableYears,
      industries: state => state.industries.items,
      categories: state => state.categories.items,
      news: state => state.news.items,
      newsLoading: state => !state.news.loaded,
      currentPage: state => state.news.currentPage,
      itemsPerPage: state => state.news.itemsPerPage,
      numberOfPages: state => state.news.numberOfPages,
      numberOfTotalItems: state => state.news.numberOfTotalItems
    }),
    selectedIndustries: {
      get () {
        return this.$store.state.industries.selected
      },
      set (payload) {
        this.$store.commit('industries/setSelected', payload)
        this.filter()
      }
    },
    selectedCategories: {
      get () {
        return this.$store.state.categories.selected
      },
      set (payload) {
        this.$store.commit('categories/setSelected', payload)
        this.filter()
      }
    },
    selectedYear: {
      get () {
        return this.$store.state.news.selectedYear
      },
      set (val) {
        this.$store.state.news.selectedYear = val
        this.filter()
      }
    }
  },
  components: {
    TypoLink,
    NewsFilter
  },
  methods: {
    ...mapActions([
      'init',
      'filter',
      'loadMore'
    ]),
    reset () {
      this.selectedIndustries = []
      this.selectedCategories = []
      this.selectedYear = null
      this.filter()
    }
  },
  created () {
    this.init()
  }
}
</script>
